import { useTable } from "react-table";
import { DeleteIcon } from "../../../../assets/svgIcons";
import { pathConstants } from "../../../../routes/pathContants";
import primaryComponents from "../../../primaryComponents";
import { useMemo, useState } from "react";
import { defaultDateDisplay } from "../../../../helpers";
import { useNavigate } from "react-router-dom";
import { useDeleteChowdeckConnection } from "../../../../hooks/api/mutations/useChowdeck";

export const useChowdeckConnectionTable = ({
  chowdeckConnectionsList = [],
  providerName,
  allowManageAPI,
  providerKey,
}) => {
  const navigate = useNavigate();
  const [deleteConnection, setDeleteConnection] = useState(null);

  const columns = useMemo(
    () => [
      {
        Header: "Lumi Business Store",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <span>{row?.original?.lumi_store?.name || "N/A"}</span>
        ),
      },
      {
        Header: `${providerName}`,
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <span>{row?.original?.marketplace_store_name || "N/A"}</span>
        ),
      },
      {
        Header: "No of Linked Products",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <span>{row?.original?.mapped_products}</span>
        ),
      },
      {
        Header: "Date Created",
        accessor: "created_at",
        Cell: ({ cell: { row } }) => (
          <span>{defaultDateDisplay(row?.original?.created_at) || "N/A"}</span>
        ),
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ cell: { row } }) => {
          const route = {
            chowdeck: pathConstants.APPS_CHOWDECK_CONNECT_STORE_EDIT({
              connection_id: row?.original?.marketplace_conn?.id,
            }),
            squareup: pathConstants.APPS_SQUAREUP_CONNECT_STORE_EDIT({
              connection_id: row?.original?.marketplace_conn?.id,
            }),
          };

          return (
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
              <primaryComponents.Button
                classNames={"btn btn--primary smallBtn"}
                onClick={() =>
                  navigate(
                    `${route?.[providerKey]}?mapping_id=${row?.original?.id}&lumi_store_id=${row?.original?.lumi_store?.id}`,
                  )
                }
              >
                Update
              </primaryComponents.Button>

              {allowManageAPI && (
                <primaryComponents.Button
                  classNames={"btn btn--outline smallBtn"}
                  onClick={() =>
                    navigate(
                      `${pathConstants.APPS_CHOWDECK_API_MANAGEMENT}?id=${row?.original?.marketplace_conn?.id}`,
                    )
                  }
                >
                  Manage API
                </primaryComponents.Button>
              )}

              <span
                className="cursor-pointer"
                onClick={() => setDeleteConnection(row?.original)}
              >
                <DeleteIcon />
              </span>
            </div>
          );
        },
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: chowdeckConnectionsList });

  const { mutate: deleteChowdeckConnection, isLoading: isDeleting } =
    useDeleteChowdeckConnection();

  const handleDeleteConnection = () => {
    deleteChowdeckConnection(
      { id: deleteConnection?.id },
      {
        onSuccess: () => {
          setDeleteConnection(null);
        },
      },
    );
  };

  return {
    instance,
    isDeleting,
    deleteConnection,
    setDeleteConnection,
    handleDeleteConnection,
  };
};
